import { Container, Col } from 'reactstrap';
import React, { useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';
import styles from './styles.module.scss';

export const Accordions = ({
    className,
    title,
    titleColour,
    items
}) => {

    // Create a state variable to track the open accordion item and its toggle class
    const [openItem, setOpenItem] = useState(null);

    const classToggle = (id) => {
        // If the clicked item is already open, close it
        if (openItem === id) {
            setOpenItem(null);
        } else {
            // Otherwise, open the clicked item
            setOpenItem(id);
        }
    };

    const [open, setOpen] = useState('');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className={`${styles.root} ${className} bg-light`}>
            <Container className="py-4 py-md-5">
                {title &&
                    <div className="mb-5 heading">
                        <h2 className={`text-${titleColour?.variant} m-0`} style={{color: titleColour?.custom}}>{title}</h2>
                    </div>
                }
                <Accordion open={open} toggle={toggle} className="row m-0">
                    {items?.map((item, index) => (
                        <Col key={index} md={6} lg={4} className={`mb-4 item rounded-4 ${open === `${index}` ? "open" : ""}`}>
                            <AccordionItem className={`border-0 bg-transparent position-relative`}>
                                <AccordionHeader
                                    targetId={`${index}`}
                                    tag="div"
                                    className={`mb-4`}
                                    onClick={() => classToggle(`${index}`)}
                                >
                                    {item?.title}
                                </AccordionHeader>
                                {item?.short_description &&
                                    <div dangerouslySetInnerHTML={{ __html: item?.short_description }} />
                                }
                                <AccordionBody accordionId={`${index}`}>
                                    {item?.content &&
                                        <div dangerouslySetInnerHTML={{ __html: item?.content }} />
                                    }
                                </AccordionBody>
                            </AccordionItem>
                        </Col>
                    ))}
                </Accordion>
            </Container>
        </section>
    )
}

export default Accordions;
